import React from "react"
import ReactDOM from "react-dom"
import {StoreProvider} from "./app/Store"
import App from "./app/App"
import ErrorBoundary from "./app/classes/ErrorBoundary"
import "./assets/css/index.scss"

// Ref https://app.logrocket.com/
// import LogRocket from 'logrocket';
// import setupLogRocketReact from 'logrocket-react';
// LogRocket.init(`b9voqm/similarchart`)
// setupLogRocketReact(LogRocket);
// LogRocket.identify(`b9voqm/similarchart`, {
//   name: `James Morrison`,
//   email: `jamesmorrison@example.com`,
//   subscriptionType: `pro`,
// })

// PWA Web Push notifications の対応
const OneSignal = window.OneSignal || []
if (process.env.ONE_SIGNAL_ID) {
  OneSignal.push(function () {
    OneSignal.init({
      appId: process.env.ONE_SIGNAL_ID,
    })
  })
}

if (process.env.SERVICE_WORKER) {
  if (`serviceWorker` in navigator) {
    window.addEventListener(`load`, () => {
      navigator.serviceWorker
        .register(`/sw.js`)
        .then((registration) => {
          console.log(`SW registered: `, registration)
          registration.onupdatefound = () => {
            console.log(`SW updated!`)
            registration.update()
          }
        })
        .catch((registrationError) => {
          console.log(`SW registration failed: `, registrationError)
        })
    })
  }
}

// 最優先の言語だけ取得
// const language = (
//   window.navigator.languages && window.navigator.languages[0]) ||
//   window.navigator.language ||
//   window.navigator.userLanguage ||
//   window.navigator.browserLanguage

// // クライアント側で受け付けている言語リストを取得
// const languages = window.navigator.languages || [
//   window.navigator.language ||
//   window.navigator.userLanguage ||
//   window.navigator.browserLanguage,
// ]

// const getQueryMap = () => {
//   const res = {}
//   const query = window.location.search.substr(1).split(`&`).map(part => {
//     const kv = part.split(`=`)
//     res[kv[0]] = decodeURIComponent(kv[1])
//   })
//   return res
// }
// const queryMap = getQueryMap()
// let search = window.location.search.substr(1).split(`&`).filter(s => !s.startsWith(`milizeToken`)).join(`&`)
// search = search.split(`&`).filter(s => !s.startsWith(`back_url`)).join(`&`)
// const url = window.location.pathname + (search ? `?` : ``) + search
// window.history.replaceState({}, document.title, url)

ReactDOM.render(
  <ErrorBoundary>
    <React.Suspense>
      <StoreProvider>
        <App />
      </StoreProvider>
    </React.Suspense>
  </ErrorBoundary>,
  document.getElementById(`root`),
)

// PWA対応
let deferredPrompt
const addBtn = document.querySelector(`.pwa-add-button`)
addBtn.style.display = `none`
window.addEventListener(`beforeinstallprompt`, (e) => {
  // Prevent Chrome 67 and earlier from automatically showing the prompt
  e.preventDefault()
  // Stash the event so it can be triggered later.
  deferredPrompt = e
  // Update UI to notify the user they can add to home screen
  addBtn.style.display = `block`
  addBtn.addEventListener(`click`, () => {
    // hide our user interface that shows our A2HS button
    addBtn.style.display = `none`
    // Show the prompt
    deferredPrompt.prompt()
    // Wait for the user to respond to the prompt
    deferredPrompt.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === `accepted`) {
        console.log(`User accepted the A2HS prompt`)
      } else {
        console.log(`User dismissed the A2HS prompt`)
      }
      deferredPrompt = null
    })
  })
})
